import { isServer } from './envChecker/index.mjs';
import memoize from 'lodash/memoize';
import MobileDetect from 'mobile-detect';

//* Reference docs: https://hgoebl.github.io/mobile-detect.js/doc/MobileDetect.html */
var isNewIpad = isServer() ? false : Boolean(window.navigator.userAgent.match(/Mac/) && window.navigator.maxTouchPoints && window.navigator.maxTouchPoints > 2);
var instance = memoize(function () {
  return new MobileDetect(window.navigator.userAgent);
});
var isApple = memoize(function () {
  var detect = instance();
  switch (detect.os()) {
    case "iPadOS" /* OS_TYPE.iPadOS */:
    case "iOS" /* OS_TYPE.iOS */:
      {
        return true;
      }
    default:
      {
        return false;
      }
  }
});
var isIOS = memoize(function () {
  var detect = instance();
  switch (detect.os()) {
    case "iOS" /* OS_TYPE.iOS */:
      {
        return true;
      }
    default:
      {
        return false;
      }
  }
});
var isAndroid = memoize(function () {
  var detect = instance();
  switch (detect.os()) {
    case "AndroidOS" /* OS_TYPE.AndroidOS */:
      {
        return true;
      }
    default:
      {
        return false;
      }
  }
});
var isMobileAgent = memoize(function () {
  var detect = instance();
  return Boolean(detect.phone() || detect.mobile());
});
var isTablet = memoize(function () {
  var detect = instance();
  return Boolean(detect.tablet()) || isNewIpad;
});
var getSafariVersion = memoize(function () {
  var detect = instance();
  return detect.version("Safari");
});
var isMoimFlutterApp = memoize(function () {
  var detect = instance();
  return detect.match("moimApp");
});

export { getSafariVersion, isAndroid, isApple, isIOS, isMobileAgent, isMoimFlutterApp, isTablet };
